import React, { Component } from 'react';
import $ from 'jquery';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import {notify} from 'react-notify-toast';
import {Row,Col} from 'react-bootstrap';


class Add extends Component{
	constructor(props){
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			saveText: 'SAVE',
			isRedirect: false,
			showLoader: false,
			showAddModal: false,		
			deptList:[]
		}
		
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.onCheckChange = this.onCheckChange.bind(this);
	}
	
	handleFormSubmit(e){
		e.preventDefault();
		this.setState({showLoader:true,saveText:'Saving..'});
		var formData = Sanitize.objectifyForm($("#frmAdd").serializeArray());
		Reqst.axPost('interview/saveInterviewSetUp',{token: Reqst.Token(formData)}).then(res=>{
			if(res['data'].status=='1')
			{
				document.getElementById("frmAdd").reset();
				notify.show(res['data'].msg,'success');
				this.setState({showLoader:false,saveText:'SAVE'});
				if(this.props.afterFinish) this.props.afterFinish();
			}
			else
			{
				notify.show(res['data'].msg,'error');
				this.setState({showLoader:false,saveText:'SAVE'});
			}
		});
	}

	componentDidMount() {
		this.loadDepartments();
	}

	loadDepartments() {
		this.setState({ showLoader: true });
		var token = Reqst.TimeStamp();
		Reqst.axGet('postcategory/getactivecategories/' + this.state.masterId + '/' + this.state.companyId + '/' + token).then(res => {
			if (res['data'].status == '1') {
				this.setState({ deptList: res['data'].data });
			}
			else {
				notify.show(res['data'].msg, 'error');
				//	this.setState({showLoader:false});	
			}
		});
	}

	onCheckChange(e) {
		if(e.target.checked){			
			$("#answer").show();
			$("#i__check").val('1');
					
		}
		else{		
			$("#answer").hide();
			$("#i__check").val('0');		
		}
	}
	
	render(){
		$("#answer").hide();
		$("#i__check").val('0');
		
		return(
			<div>			
				<form action="" method="post" encType="multipart/form-data" id="frmAdd" onSubmit={this.handleFormSubmit} >
					<input type="hidden" name="i__lid" value={this.state.loginId} />
					<input type="hidden" name="i__company" value={this.state.companyId} />
					<input type="hidden" name="i__master" value={this.state.masterId} />
					<Row>
						<Col md={12} >
						    <label>Category<span className="text-danger">*</span></label>
							<select name="i__cat"  id="i__cat" className="form-control input-sm" required>
								<option value="">Select Category</option>
								{this.state.deptList.map((item, i) =>
									<option value={item.id} >{item.categoryname}</option>
								)}
							</select>
						</Col>
					</Row><br/>
					<Row>
						<Col md={12} >
							<label>From Date<span className="text-danger">*</span></label>
							<input type="date" name="i__fdate" id="i__fdate" className="form-control input-sm" required />
						</Col>
					</Row><br/>
					<Row>
						<Col md={12} >
							<label>To Date<span className="text-danger">*</span></label>
							<input type="date" name="i__tdate" id="i__tdate" className="form-control input-sm" required />
						</Col>
					</Row><br/>				
					<Row>
						<Col md={12} >
							<label>Time<span className="text-danger">*</span></label>
							<input type="time" name="i__ttime" id="i__ttime"  className="form-control input-sm" required />
						</Col>
					</Row><br/>						
					<Row>
						<Col md={12} >
							<br />
							<div className="text-right" >
								<button type="submit" className="btn btn-info btn-sm btn-success_2" disabled={this.state.saveText!='SAVE'} >
									<i className="fa fa-check"></i> {this.state.saveText} 
								</button>
							</div>
						</Col>
					</Row>
				</form>
			</div>
		);
	}
	
}
export default Add;